import IndexPage from "../Crud/IndexPage"
import { useModal } from "../../Components/Modal"
import AllUserManagement from "./AllUserManagement"
import AllWorkspaceManagement from "./AllWorkspaceManagement"
import SubscriptionManagement from "./SubscriptionManagement"
const AdminPanel = () => {
    const { ModalView, openModal } = useModal()

    return (
        <>
            <IndexPage title="Admin Panel" items={[
                { text: "User Verwaltung", icon: "user", action: () => openModal(<AllUserManagement />) },
                { text: "Alle Workspaces", icon: "building-store", action: () => openModal(<AllWorkspaceManagement />) },
                {text: "Subscriptions Verwalten", icon: "brand-stripe", action: () => openModal(<SubscriptionManagement/>)}
            ]} />
            <ModalView />
        </>

    )
}
export default AdminPanel